import { IStudyNoteControlsResolver } from './IStudyNoteControlsResolver';
import {
  FormCheckboxGroupInput,
  FormDateInput,
  FormDateRangeInput,
  FormDropDownInput,
  FormMultipleDropdownInput,
  FormMultipleTextInput,
  FormNumberInput,
  FormRadioGroupInput,
  FormSliderInput,
  FormTagInput,
  FormTextInput,
  FormTimeInput,
} from './fillingComponents/inputs';
import { FormFileInput } from './fillingComponents/inputs/formFileInput';
import { Container, RootContainer, RepeatableContainer, RepeatableSection } from './fillingComponents/containers';
import { FormDividingLine, ImageBlock, TextBlock } from './fillingComponents/content';

export const studyNoteFillControlsResolver: IStudyNoteControlsResolver = {
  // Containers
  RootContainer: RootContainer,
  Container: Container,
  RepeatableContainer: RepeatableContainer,
  RepeatableSection: RepeatableSection,

  // Content
  FormText: TextBlock,
  FormDividingLine: FormDividingLine,
  FormImage: ImageBlock,

  // Inputs
  FormTextInput: FormTextInput,
  FormMultipleTextInput: FormMultipleTextInput,
  FormNumberInput: FormNumberInput,
  FormSliderInput: FormSliderInput,
  FormDateInput: FormDateInput,
  FormDateRangeInput: FormDateRangeInput,
  FormTimeInput: FormTimeInput,
  FormRadioGroupInput: FormRadioGroupInput,
  FormDropdownInput: FormDropDownInput,
  FormCheckboxGroupInput: FormCheckboxGroupInput,
  FormMultipleDropdownInput: FormMultipleDropdownInput,
  FormTagInput: FormTagInput,

  FormFileInput: FormFileInput,
};
